<template lang="pug">
form.v-form.form(
		ref="form"
		@submit.prevent="submit"
		novalidate
		autocomplete="off")
	v-loader(:loading="loading")
	//template(v-if="form && form.success && form.message")
	//	.form__success-message
	//		v-svg-icon.form__success-message-icon(:icon="form.message?.icon")
	//		h2.form__success-message-text(v-if="form.message.text" ) {{ form.message.text }}

	template(v-if="form && form.errors && form.errors.form && form.errors.form.length")
		.form__form-errors
			template(v-if="Array.isArray(form.errors.form) && form.errors.form.length")
				template(v-for="error in form.errors.form")
					.form__form-error.flc(v-html="error")
			template(v-else)
				.form__form-error.flc(v-html="form.errors.form")

	template(v-if="form && (!form.success || !form.hideFormOnSuccess)")
		.form__header.flc.fcc(v-if="form.title || form.titleNote")
			h2.form__header-title.flc(v-if="form.title") {{form.title}}
			.form__header-note.flc(v-if="form.titleNote" v-html="form.titleNote")

		.form__main.flc.fcc(v-if="form.tabs && form.tabs.length && form.groups && form.groups.length")
			.form__tabs
				template(v-for="(tab, tabIndex) in form.tabs" :key="tabIndex")
					.form__tab(v-if="tab.title"
							:class="{'active': tab?.id === this.currentTabId}"
							@click="setCurrentTabId(tab?.id)")
							| {{ tab.title }}
			.form__groups
				template(v-for="(group, groupIndex) in form.groups" :key="groupIndex")
					template(v-if="group.tabId === this.currentTabId" )
						.form__group(:style="{width: group.width || null}")
							h3.form__group-title.flc(v-if="group.title") {{group.title}}
							.form__group-body.flc
								.form__fields
									template(v-for="(field, fieldIndex) in form.fields" :key="fieldIndex")
										template(v-if="field.groupId === group.id")
											.form__field(v-if="field.type !== 'hidden'" :style="{width: field.width || null}")
												v-field(:field="field"
														v-model="field.value"
														:errors="getFieldError(field)"
														@emmitData="emmitData"
														@fileinput="fileInput(field, $event)"
														@fileremove="fileRemove(field, $event)"
														@remove="valueRemove(field, $event)"
														@update:model-value="fieldChanged(field, $event)"
														@request-code="requestCode")

							.form__group-note.flc(v-if="group.note" v-html="group.note")
						.form__group.form__group--alt(v-if="form.requireConfirm && form.requireConfirmText")
							.form__group-body.flc
								.form__fields
									.form__field.form__field--flex
										v-field.field--big-checkbox(
												:field="computedConfirmField"
												v-model="confirmValue"
												@update:model-value="confirmed = !confirmed")

		.form__main.flc.fcc(v-else-if="form.groups && form.groups.length")
			.form__groups
				template(v-for="(group, groupIndex) in form.groups" :key="groupIndex")
					.form__group(:style="{width: group.width || null}")
						h3.form__group-title.flc(v-if="group.title") {{group.title}}
						.form__group-note.flc(v-if="group.note" v-html="group.note")
						.form__group-body.flc
							.form__fields
								template(v-for="(field, fieldIndex) in form.fields" :key="fieldIndex")
									template(v-if="field.groupId === group.id")
										.form__field(v-if="field.type !== 'hidden'" :style="{width: field.width || null}")
											v-field(:field="field"
													v-model="field.value"
													:errors="getFieldError(field)"
													@emmitData="emmitData"
													@fileinput="fileInput(field, $event)"
													@fileremove="fileRemove(field, $event)"
													@remove="valueRemove(field, $event)"
													@update:model-value="fieldChanged(field, $event)"
													@request-code="requestCode"
													:id="field.code || field.id")
				.form__group.form__group--alt(v-if="form.requireConfirm && form.requireConfirmText")
					.form__group-body.flc
						.form__fields
							.form__field.form__field--flex
								v-field.field--big-checkbox(
										:field="computedConfirmField"
										v-model="confirmValue"
										@update:model-value="confirmed = !confirmed")

		.form__footer.flc(v-if="form.buttons && form.buttons.length")
			.form__actions(v-if="form.buttons")
				template(v-for="(button, buttonIndex) in form.buttons" :key="buttonIndex")
					.form__action
						.form__action-label {{button.label}}
						button.btn.btn--primary.btn--round.form__action-button(:type="button.type || 'submit'"
								:class="button.className || 'btn btn--primary'"
								:disabled="form.requireConfirm ? !confirmed : null"
								:data-modal-url="button.modalUrl"
								:data-modal-data="button?.modalData || null")
							| {{button.text}}
			.form__note(v-if="form.note" v-html="form.note" )
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller';
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		}
	},

	emits: [
		'success',
		'form-submited',
		'request-code',
		'updateTabId',
		'redirect'
	],

	data() {
		return {
			form: null,
			localFormData: new FormData(),
			modalTimeout: null,
			confirmValue: [],
			confirmed: false,
			savedFileKeys: [],
			currentTabId: null,
			isErrorsFound: false,
			localFiles: {}
		};
	},

	computed: {
		computedConfirmField() {
			return {
				type: 'check-list',
				value: [],
				label: null,
				options: [
					{
						'value': '1',
						'text': this.form.requireConfirmText
					}
				]
			};
		}
	},
	created() {
	},
	watch: {
		isErrorsFound() {
			if(this.isErrorsFound && this.form.errors.fields.length) {
				this.scrollToFirstError()
			}
		}
	},

	methods: {
		requestCode() {
			this.submit({action: 'new-code'});
		},

		getFieldError(field) {
			if (this.form.errors && this.form.errors.fields) {
				let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
				this.isErrorsFound = true
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},

		setCurrentTabId(id) {
			this.currentTabId = id;
			this.$emit('updateTabId', this.currentTabId);
		},

		scrollToFirstError() {
			if (!this) {
				return;
			}
			if (document.body.classList.contains('state--modal-open')) {
				return;
			}

			this.$nextTick(() => {
				const $errorFields = this.$refs.form.querySelectorAll('.form-error');
				if ($errorFields.length > 0) {
					const $firstErrorField = $errorFields[0];
					const yOffset = -10;
					const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: coordY, behavior: 'smooth'});
				} else {
					window.scrollTo({top: 0, behavior: 'smooth'});
				}
			})

		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		updateForm() {
			this.submit({action: 'autosubmit'});
			console.log('form-submited')
		},

		dataSet(data) {
			if (data?.redirect) {
				this.$emit('redirect');
			}
			this.isErrorsFound = false

			if(data?.tabs && data?.tabs.length) {
				if(data?.activeTabId) {
					this.currentTabId = data?.activeTabId
				} else {
					this.currentTabId = data.tabs[0]?.id
				}
			}

			if(data.updateUsers) {
				window.modalController.closeAll();
				controller.updateUsers();
			}

			if(data.updateForm) {
				window.modalController.closeAll();
				controller.updateForm();
			}

			if (data.success && data.closeModal) {
				if (typeof modalController !== 'undefined') {
					if (typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
						clearTimeout(this.modalTimeout);
						this.modalTimeout = setTimeout(() => {
							controller.closeModal();
						}, data.modalTimeout);
					} else {
						controller.closeModal();
					}
				}
				return;
			}
			if (data.modal) {
				window.modalController.closeAll();
				// открыть модальное окно с сообщением об успешной отправке формы
				setTimeout(() => {
					if(data.modal.content) {
						controller.openModal({
							className: data.modal.className,
							content: `<v-modal-window>${data.modal.content}</v-modal-window>`
						});
					} else if(data.modal) {
						controller.openModal({
							...data.modal
						})
					}

				}, 300)

			}
			if(data.updateOut) {
				this.$emit('update-out', data);
			}
			if (data.success && data.message) {
				this.$emit('success',data.message );
			}

			if (data.emit_event) {
				controller.emitCustomEvent(data.emit_event);
			}

			this.form = data;
		},

		emmitData(data) {
		},

		submit(options = {}) {
			let namesOfCurrentIteration = [];
			// for(let item of this.localFormData.entries()) {
			// 	console.log(item);
			// }

			if (this.form && this.form.fields) {
				this.form.fields.forEach(field => {
					let key = this.proxyFieldName(field.name);

					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type === 'file' || field.type === 'avatar') {
						//очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							let isfoundInSavedFileKeys = false;
							for (let j = 0; j < this.savedFileKeys.length; j++) {
								if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
									isfoundInSavedFileKeys = true;
									break;
								}
							}
							if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
								this.localFormData.delete(item[0]);
							}
						}

						if(field.typeContent === 'image') {
							if(this.localFormData.has(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]')) {
								this.localFormData.delete(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]')
							}
							if(field?.main) {
								this.localFormData.append(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]', field.main);
							} else if(this.form.mainImageKey) {
								this.localFormData.append(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]', this.form.mainImageKey);
							}
						}
						// обработка файлов происходит в fileInput / fileRemove
						// здесь ничего делать не нужно
						/*
						 _.each(field.value, (fileListItem) => {
						 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
						 });
						 */
					} else {
						// для отправки файлов придется держать в памяти неизменный localFormData
						// перед отправкой нужно удалить старые значения из localFormData
						// т.к. localFormData.append добавляет новые значения к существующим
						// а localFormData.set не позволила бы работать с массивами типа NAME[]

						// this.localFormData.keys().forEach(key => this.localFormData.delete(key))


						if (namesOfCurrentIteration.indexOf(key) < 0) {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}

						if(field.type === 'schedule') {
							field.value.forEach((item, index) => {
								Object.entries(item).forEach(([key, val]) => {
									if(Array.isArray(item[key])) {
										item[key].forEach((value, valueIndex) => {
											this.localFormData.append(`${this.proxyFieldName(field.name)}[${index}][${key}][${valueIndex}]`, value);
										})
									} else {
										this.localFormData.append(`${this.proxyFieldName(field.name)}[${index}][${key}]`, item[key]);
									}
								})
							})
							return;
						}

						if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								if(field?.type === 'translate' || field?.type === 'map') {
									Object.entries(val).forEach(([objectKey, objectValue]) => {
										if (namesOfCurrentIteration.indexOf(`${key}[${index}][${objectKey}]`) < 0) {
											this.localFormData.delete(`${key}[${index}][${objectKey}]`);
											namesOfCurrentIteration.push(`${key}[${index}][${objectKey}]`);
										}
										this.localFormData.append(`${key}[${index}][${objectKey}]`, objectValue)
									})

								} else {
									if (namesOfCurrentIteration.indexOf(`${key}[${index}]`) < 0) {
										this.localFormData.delete(`${key}[${index}]`);
										namesOfCurrentIteration.push(`${key}[${index}]`);
									}
									this.localFormData.append(`${key}[${index}]`, val);

								}
							});
						} else if(field?.type === 'translate' || field?.type === 'map') {
							Object.entries(field.value).forEach(([objectKey, objectValue]) => {
								if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}]`) < 0) {
									this.localFormData.delete(`${key}[${objectKey}]`);
									namesOfCurrentIteration.push(`${key}[${objectKey}]`);
								}

								this.localFormData.append(`${key}[${objectKey}]`, objectValue)

							})
						} else if(field?.type && typeof field.value === 'object') {
							Object.entries(field.value).forEach(([objectKey, objectValue]) => {

								if(!Array.isArray(objectValue) && typeof objectValue !== 'object') {
									if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}]`) < 0) {
										this.localFormData.delete(`${key}[${objectKey}]`);
										namesOfCurrentIteration.push(`${key}[${objectKey}]`);
									}

									this.localFormData.append(`${key}[${objectKey}]`, objectValue)
								}

								if(Array.isArray(objectValue)) {
									for(let i = 0; i < objectValue.length; i++) {
										if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objectValue}][${i}]`) < 0) {
											this.localFormData.delete(`${key}[${objectKey}][${i}]`);
											namesOfCurrentIteration.push(`${key}[${objectKey}][${i}]`);
										}

										this.localFormData.append(`${key}[${objectKey}][${i}]`, objectValue[i])

									}
								}

								if(!Array.isArray(objectValue) && typeof objectValue === 'object'){
									Object.entries(objectValue).forEach(([objKey, objValue]) => {

										if(Array.isArray(objValue)) {
											for(let i = 0; i < objValue.length; i++) {
												if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objKey}][${i}]`) < 0) {
													this.localFormData.delete(`${key}[${objectKey}][${objKey}][${i}]`);
													namesOfCurrentIteration.push(`${key}[${objectKey}][${objKey}][${i}]`);
												}

												this.localFormData.append(`${key}[${objectKey}][${objKey}][${i}]`, objValue[i])

											}
										} else {

											if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objKey}]`) < 0) {
												this.localFormData.delete(`${key}[${objectKey}][${objKey}]`);
												namesOfCurrentIteration.push(`${key}[${objectKey}][${objKey}]`);
											}

											this.localFormData.append(`${key}[${objectKey}][${objKey}]`, objValue)
										}
									})
								}
							})

						} else {

							this.localFormData.append(key, field.value);

						}
					}
				});
			}


			this.localFormData.set('state[action]', options.action || 'submit');
			if (options.triggerField) {
				this.localFormData.set('state[triggerField]', options.triggerField);
			}
			this.localFormData.set('bxajaxid', this.form.bxajaxid);

			if(this.currentTabId) {
				this.localFormData.set('activeTabId', this.currentTabId);
			}

			if (this.confirmed) {
				this.localFormData.append('confirmed', 1);
			} else {
				this.localFormData.delete('confirmed');
			}
			this.dataLoad({
				url: this.form.remote,
				data: this.localFormData,
				delay: true
			});

			if (this.form && this.form.fields) {
				this.form.fields.forEach(field => {
					if (field.type === 'file') {
						// очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							if(field.type === 'file') {
								for (let item of this.localFormData.keys()) {
									for (let j = 0; j < this.savedFileKeys.length; j++) {
										if (item[0].indexOf(this.savedFileKeys[j]) < -1) {
											this.localFormData.delete(item);
										}
									}
								}
							}
						}
					}
				});
			}

			this.$emit('form-submited');
		},

		fieldChanged(field) {
			if (field.autosubmit) {
				this.submit({action: 'autosubmit', triggerField: field.name});
			}
		},

		// async getFileFromUrl(url, type, name){
		// 	let response = await fetch(url);
		// 	let data = await response.blob();
		// 	let metadata = {
		// 		type: type
		// 	};
		// 	return new File([data], name, metadata);
		// },

		async fileInput(field, e) {
			// хранение докальных файлов
			this.localFiles[field.name] = e.target.files

			for (let i = 0; i < e.target.files.length; i++) {

				let {
					key = uniqueId()
				} = e.target.files[i];
				// console.log('e.target.files',e.target.files)
				// console.log('input', this.proxyFieldName(field.name) + '[' + key + ']')


				this.savedFileKeys.push(key);
				this.localFormData.append(this.proxyFieldName(field.name) + '[' + key + ']', e.target.files[i].path || e.target.files[i]);


				for (var pair of this.localFormData.entries()) {
					console.log(pair[0]+ ', ' + pair[1]);
				}
				// if(e.target.files[i].path) {
				// 	let file;
				// 	await this.getFileFromUrl(e.target.files[i].path, e.target.files[i].type || 'image/jpeg', e.target.files[i].name || '').then((result) => {
				// 		file = result
				// 	});
				//
				// 	this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', file);
				// } else {
				// 	this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i]);
				// }
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit', triggerField: field.name });
			}
		},

		fileRemove(field, e) {
			if(Array.isArray(e)) {
				if(e[1] === 'avatar') {
					this.localFormData.append(this.proxyFieldName(field.name) + '[' + e[0].key + ']', '');
				}
			} else {
				for (var pair of this.localFormData.entries()) {
					console.log(pair[0]+ ', ' + pair[1]);
				}
				this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit', triggerField: field.name});
			}
		},

		valueRemove(field, e) {
			// remove error of removed value
			if (field.errors && field.errors.length) {
				field.errors.splice(e, 1);
			}
		}
	}
};
</script>